import { Fragment } from "react";
import { flexRender } from "@tanstack/react-table";
import { ReactComponent as IconInformationCircle } from "@/assets/svgs/information-circle-transparent.svg";
import PropTypes from "prop-types";

function NoRecords() {
	return (
		<div className="DS__data-table3__empty">
			<IconInformationCircle />
			No results found.
		</div>
	);
}

const TableBody = ({ table }) => {
	const errors = table?.options?.meta?.errors || [];

	return (
		<div
			{...{
				className: "tbody",
			}}
		>
			{table?.getRowModel()?.rows?.length > 0 ? (
				table.getRowModel().rows.map((row) => {
					const hasRowError = errors.some(error => 
						error.cellId?.startsWith(row.id)
					);
					return (
						<Fragment key={row.id}>
							<div
								{...{
									"data-testid": "DS__data-table3-row",
									className: `tr ${hasRowError ? 'DS__table-row-error' : ''}`,
								}}
							>
								{row.getVisibleCells().map((cell) => {
									return (
										<div
											{...{
												key: cell.id,
												className: "td",
												style: {
													minWidth: `calc(var(--col-${cell.column.id}-size) * 1px)`,
													width: cell.column?.columnDef
														?.flex
														? undefined
														: `calc(var(--header-${cell.column?.id}-size) * 1px)`,
													flex: cell?.column?.columnDef
														?.flex
														? `${cell.column.columnDef.flex} 1 0`
														: undefined,
												},
											}}
										>
											<div>
												{flexRender(
													cell.column.columnDef.cell,
													cell.getContext()
												)}
											</div>
										</div>
									);
								})}
							</div>
						</Fragment>
					);
				})
			) : (
				<NoRecords />
			)}
		</div>
	);
};

TableBody.propTypes = {
	table: PropTypes.object,
};

export default TableBody;
